import {Constructor} from "../../../../global/constructor";
import {
  ICertificateElementContainer,
  ISortableCertificateElement,
} from "~/interfaces/contentManagementInterfaces";
import TrackedModel from "~/models/tracked/trackedModel";

export default function ImageElement<TBase extends Constructor,
  TCertificateElement extends ISortableCertificateElement &
    TrackedModel,
  TContainer extends TrackedModel &
    ICertificateElementContainer<TCertificateElement> &
    TCertificateElement>(Base: TBase) {
  return class extends Base {
    htmlImage: any;
    file_upload_id: string;
    except = ['htmlImage', 'createEmbeddedObject', 'organization_id'];
  }
}